import React, { memo } from 'react';

import { useCartContext } from '../../../provider/cart/CartContext';

import Portal from '../../atoms/portal';
import MiniCart from '../minicartDropdown/MiniCart';
import MobileMinicartConfirmation from '../minicartDropdown/mobileMinicartConfirmation/MobileMinicartConfirmation';

const Cart = ({ shippingCoastMessage, loggedIn, promo, nostoBlocks, customerGroupId }) => {
  const { cartData, showCart, showCartConfirmation, setShowCartConfirmation } =
    useCartContext();

  if (!cartData.cart) {
    return null;
  }

  return (
    <div>
      <MiniCart
        showDialog={showCart}
        items={cartData?.cart?.lineItems}
        data={cartData?.cart}
        loggedIn={loggedIn}
        shippingCoastMessage={shippingCoastMessage}
        nostoBlocks={nostoBlocks}
        promo={promo}
        customerGroupId={customerGroupId}
      />
      <Portal>
        <MobileMinicartConfirmation
          showDialog={showCartConfirmation}
          setShowDialog={setShowCartConfirmation}
          items={cartData?.cart?.lineItems}
          data={cartData?.cart}
          loggedIn={loggedIn}
          shippingCoastMessage={shippingCoastMessage}
        />
      </Portal>
    </div>
  );
};

export default memo(Cart);
